/* @flow */

import { useEffect, useRef } from "react";

const usePrevious = (value: any): void | any => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
